import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

interface IUIState {
	page: string;
	history: string[];
	to?: string;
	checkBeforeNavigate: boolean;
	isMobile: boolean;
	success?: string;
}

const initialState: IUIState = {
	page: '/',
	history: [''],
	checkBeforeNavigate: false,
	isMobile: window.innerWidth < 600,
};

export const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		togglePage: (state, action: PayloadAction<string | undefined>) => {
			state.to = action.payload;
		},
		setPage: (state, action: PayloadAction<string>) => {
			state.to = undefined;
			state.checkBeforeNavigate = false;
			state.history.push(state.page);
			state.page = action.payload;
		},
		setCheckBeforeNavigate: (state, action: PayloadAction<boolean>) => {
			state.checkBeforeNavigate = action.payload;
		},
		setMobile: (state, action: PayloadAction<boolean>) => {
			state.isMobile = action.payload;
		},
		setSuccessMessage: (state, action: PayloadAction<string | undefined | boolean>) => {
			state.success = _.isBoolean(action.payload)
				? action.payload
					? 'action.success'
					: undefined
				: action.payload;
		},
	},
});

export const { togglePage, setPage, setCheckBeforeNavigate, setMobile, setSuccessMessage } = uiSlice.actions;

export const ifPageChange = (state: any) => {
	return state.ui?.to && !_.isEqual(state.ui.to, state.ui.page) ? true : false;
};

export const getToNavigation = (state: any) => {
	return state.ui.to;
};

export const getUi = (state: any) => {
	return state.ui;
};

export const getHistory = (state: any) => {
	return state.ui.history;
};

export const getMobile = (state: any) => {
	return state.ui.isMobile;
};

export default uiSlice.reducer;
